import cx from 'classnames';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import { forwardRef } from 'react';
import { useBoxSelectorContext } from './BoxSelectorContext.js';

export const BoxSelectorContent = forwardRef<
  ElementRef<'div'>,
  BoxSelectorContent.Props
>(function BoxSelectorContent(
  { children, className, ...rest }: BoxSelectorContent.Props,
  ref,
) {
  const { isTagBox, autoColumns } = useBoxSelectorContext();
  return (
    <div
      ref={ref}
      className={cx('box-selector__content', className, {
        'box-selector__content--grid': !isTagBox,
        'box-selector__content--grid-fluid': !isTagBox && autoColumns,
        'box-selector__content--tag-box': isTagBox,
      })}
      {...rest}
    >
      {children}
    </div>
  );
});

BoxSelectorContent.displayName = 'BoxSelectorContent';

// eslint-disable-next-line @typescript-eslint/no-redeclare
export namespace BoxSelectorContent {
  export interface Props extends ComponentPropsWithoutRef<'div'> {}
}
